import { removeEmojiPrefix } from 'shared/utils/removeEmojiPrefix'

/**
 * Resolve subcategories for a stored (emoji-free) category — same as AiToolNew useMemo.
 */
export function getCourseMapSubCategories(courseMap, category) {
	if (!courseMap || !category) return []
	const stripped = removeEmojiPrefix(category) || category
	const categoryKey = Object.keys(courseMap).find(
		key => removeEmojiPrefix(key) === stripped,
	)
	return categoryKey ? courseMap[categoryKey] || [] : []
}

/**
 * Display label (with emoji) for a stored category.
 */
export function getCourseMapCategoryLabel(courseMap, category) {
	if (!category) return ''
	const stripped = removeEmojiPrefix(category) || category
	const categoryKey = Object.keys(courseMap || {}).find(
		key => removeEmojiPrefix(key) === stripped,
	)
	return categoryKey || category
}

/**
 * Display label (with emoji) for a stored subCategory under a category.
 */
export function getCourseMapSubCategoryLabel(courseMap, category, subCategory) {
	if (!subCategory) return ''
	const stripped = removeEmojiPrefix(subCategory) || subCategory
	const list = getCourseMapSubCategories(courseMap, category)
	const match = list.find(item => removeEmojiPrefix(item) === stripped)
	return match || subCategory
}
